import { createSlice } from "@reduxjs/toolkit";

const menuSlice = createSlice({
  name: "roleSetter",
  initialState: {
    menu: [
      { name: "Dashboard", url: "/admin/dashboard", allow: true , selected:true},
    ],
  },
  reducers: {
    setMenu: (state, action) => {
      state.menu = action.payload;
    },
  },
});

export const { setMenu } = menuSlice.actions;

export default menuSlice.reducer;
